export const ONELINK = 'https://reccall.onelink.me/KKOx/z9i5tzuf'